import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, Input } from "@angular/core";
import { Action, Conditional, FieldAction } from "../model";
import { FormDefinition } from "../../vforms-model";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { NotifyService } from "@ui/notify";
import { TranslocoService } from "@jsverse/transloco";

@Component({
    selector: "conditional-component",
    templateUrl: "./conditional.component.html",
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConditionalComponent {
    @Input()
    formDefinition: FormDefinition;

    @Input()
    conditional: Conditional;

    public possibleActions = [Action.Display, Action.Hide, Action.Enable, Action.Disable];

    constructor(
        private _dialogRef: MatDialogRef<ConditionalComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private _changeDetector: ChangeDetectorRef,
        private _notifyService: NotifyService,
        private _transoloService: TranslocoService
    ) {
        this.conditional = this.data.conditional;
        if (this.conditional.positiveActions.length === 0) {
            this.conditional.defaultActions();
        }
        this.formDefinition = this.data.form;
    }

    getAvailableFields(fieldActions: FieldAction[], fieldAction: FieldAction) {
        let fields = [];
        for (let field of this.formDefinition.fields) {
            let exists = fieldActions.findIndex((a) => a !== fieldAction && a.field?.id === fieldAction.field?.id) >= 0;
            if (!exists) {
                fields.push(field);
            }
        }
        return fields;
    }

    save() {
        if (this.conditional.isValid()) {
            this.conditional.removeDefaultActions();
            this._dialogRef.close(this.conditional);
        } else {
            this._notifyService.warn(this._transoloService.translate("expression-settings.incomplete-info-error"));
        }
    }

    newPositiveAction() {
        this.conditional.newPositiveAction();
        this._changeDetector.markForCheck();
    }

    removePositiveAction(fieldAction: FieldAction) {
        this.conditional.removePositiveAction(fieldAction);
        this._changeDetector.markForCheck();
    }

    newNegativeAction() {
        this.conditional.newNegativeAction();
        this._changeDetector.markForCheck();
    }

    removeNegativeAction(fieldAction: FieldAction) {
        this.conditional.removeNegativeAction(fieldAction);
        this._changeDetector.markForCheck();
    }
}
